import React from "react";
import FinanceApprovalPageHeader from "views/pages/manage/unAssigned/studentFinanceApproval/components/ApprovalPageHeader";
import ApprovalListingWrapper from "./ApprovalListingWrapper";
import { approvalConfig } from "../shared/config";

const ApprovalDashboard = ({ userPermissions, type }) => {
  const config = approvalConfig[type];

  return (
    <div>
      <FinanceApprovalPageHeader
        heading={config.heading}
        subHeading={config.subHeading}
      />
      <ApprovalListingWrapper
        userPermissions={userPermissions}
        type={type}
        heading={config.heading}
      />
    </div>
  );
};


export default ApprovalDashboard;